export default __webpack_public_path__ + "static/media/Instagram.754db1d2.png";